import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpHeaderHelper } from 'src/app/model';
@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }

  buildHeaders(headers: Array<HttpHeaderHelper>): HttpHeaders {
    let headerObj: { [key: string]: string } = {}
    for(let header of headers) {
      if (header.key && header.value) {
        headerObj[header.key] = header.value;
      }
    }
    let httpHeaders: HttpHeaders = new HttpHeaders(headerObj);
    return httpHeaders;
  }
}
